export default __webpack_public_path__ + "static/media/Print-483.1298d254.jpg";